// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contactStatusEntity from './entities/contact-status.json';
import contactStatusMenu from '../pages/contact-status/menu.json';
import contactStatusFullForm from '../pages/contact-status/forms/full.json';
import contactStatusContextForm from '../pages/contact-status/forms/context.json';
import contactStatusMiniForm from '../pages/contact-status/forms/mini.json';
import contactStatusLookupForm from '../pages/contact-status/forms/lookup.json';
import contactStatusTableView from '../pages/contact-status/views/table.json';
import contactStatusDashboardView from '../pages/contact-status/views/dashboard.json';

/** Тип запису «Статус контакту» зі сторінками пакета: меню, форми та подання з pages/contact-status/. */
export const contactStatusDefinition: IRecordTypeDefinition = {
  ...contactStatusEntity,
  views: assembleViewSet({
      table: contactStatusTableView,
      dashboard: contactStatusDashboardView,
  }),
  form: contactStatusFullForm,
  forms: { full: contactStatusFullForm, context: contactStatusContextForm, mini: contactStatusMiniForm, lookup: contactStatusLookupForm },
  menu: contactStatusMenu,
} as IRecordTypeDefinition;
